import {
  useLazyGetAllDetailsComponentsQuery,
  useLazyGetAllListComponentsQuery,
  useLazyGetAllPageLayoutQuery,
} from "../../../store/services/componentsQuery";

export const useUiConfig = () => {
  const [
    getAllListComponents,
    {
      data: getAllListComponentsData,
      isLoading: getAllListComponentsIsLoading,
      isError: getAllListComponentsIsError,
      error: getAllListComponentsError,
      isSuccess: getAllListComponentsIsSuccess,
    },
  ] = useLazyGetAllListComponentsQuery();

  const [
    getAllDetailsComponents,
    {
      data: getAllDetailsComponentsData,
      isLoading: getAllDetailsComponentsIsLoading,
      isError: getAllDetailsComponentsIsError,
      error: getAllDetailsComponentsError,
      isSuccess: getAllDetailsComponentsIsSuccess,
    },
  ] = useLazyGetAllDetailsComponentsQuery();

  const [
    getAllPageLayout,
    {
      data: getAllPageLayoutData,
      isLoading: getAllPageLayoutIsLoading,
      isError: getAllPageLayoutIsError,
      error: getAllPageLayoutError,
      isSuccess: getAllPageLayoutIsSuccess,
    },
  ] = useLazyGetAllPageLayoutQuery();

  return {
    getAllListComponents,
    getAllListComponentsData,
    getAllListComponentsIsLoading,
    getAllListComponentsIsError,
    getAllListComponentsError,
    getAllListComponentsIsSuccess,
    getAllDetailsComponents,
    getAllDetailsComponentsData,
    getAllDetailsComponentsIsLoading,
    getAllDetailsComponentsIsError,
    getAllDetailsComponentsError,
    getAllDetailsComponentsIsSuccess,
    getAllPageLayout,
    getAllPageLayoutData,
    getAllPageLayoutIsLoading,
    getAllPageLayoutIsError,
    getAllPageLayoutError,
    getAllPageLayoutIsSuccess,
  };
};
